/**
 * Mock data for sizing dashboard development.
 * Set USE_MOCK_DATA to false to use real API data.
 */
export const USE_MOCK_DATA = false;

export const MOCK_DIAGNOSTIC = [
  {
    productId: "prod-001",
    productTitle: "T-shirt Oversize Classic",
    imageUrl: "https://picsum.photos/seed/tshirt1/200",
    recommendation: "runs_large" as const,
    ratio: 0.72,
    sampleSize: 145,
    sizeTooLargeCount: 89,
    sizeTooSmallCount: 12,
  },
  {
    productId: "prod-002",
    productTitle: "Slim Fit Jeans Dark Blue",
    imageUrl: "https://picsum.photos/seed/jeans1/200",
    recommendation: "runs_small" as const,
    ratio: 0.65,
    sampleSize: 230,
    sizeTooLargeCount: 15,
    sizeTooSmallCount: 134,
  },
  {
    productId: "prod-003",
    productTitle: "Hoodie Zip Essential",
    imageUrl: "https://picsum.photos/seed/hoodie1/200",
    recommendation: "runs_large" as const,
    ratio: 0.58,
    sampleSize: 87,
    sizeTooLargeCount: 42,
    sizeTooSmallCount: 8,
  },
  {
    productId: "prod-004",
    productTitle: "Robe d'été Fleurie",
    imageUrl: "https://picsum.photos/seed/robe1/200",
    recommendation: "runs_small" as const,
    ratio: 0.45,
    sampleSize: 312,
    sizeTooLargeCount: 22,
    sizeTooSmallCount: 119,
  },
  {
    productId: "prod-005",
    productTitle: "Veste en Cuir Biker",
    imageUrl: "https://picsum.photos/seed/veste1/200",
    recommendation: "runs_large" as const,
    ratio: 0.38,
    sampleSize: 64,
    sizeTooLargeCount: 20,
    sizeTooSmallCount: 4,
  },
  {
    productId: "prod-006",
    productTitle: "Pantalon Chino Regular",
    imageUrl: "https://picsum.photos/seed/chino1/200",
    recommendation: "runs_small" as const,
    ratio: 0.33,
    sampleSize: 198,
    sizeTooLargeCount: 11,
    sizeTooSmallCount: 54,
  },
  {
    productId: "prod-007",
    productTitle: "Pull Col Roulé Mérinos",
    imageUrl: "https://picsum.photos/seed/pull1/200",
    recommendation: "runs_large" as const,
    ratio: 0.29,
    sampleSize: 156,
    sizeTooLargeCount: 38,
    sizeTooSmallCount: 7,
  },
];

const DAY = 24 * 60 * 60 * 1000;
const todayMs = Date.now();
const todayDay = todayMs - (todayMs % DAY);
const activatedAt = todayDay - 45 * DAY;

export const MOCK_DAILY_RECOMMENDATIONS = Array.from(
  { length: 90 },
  (_, i) => {
    const date = todayDay - (89 - i) * DAY;
    const isAfterActivation = date >= activatedAt;
    const base = isAfterActivation ? 42 : 0;
    const count = isAfterActivation
      ? Math.max(0, Math.round(base + (Math.random() - 0.3) * 28))
      : 0;
    return { date, count };
  },
);

function generateTimeSeries() {
  const points = [];
  for (let i = 90; i >= 0; i--) {
    const date = todayDay - i * DAY;
    const isAfter = date > activatedAt;
    const baseRate = isAfter ? 0.06 : 0.12;
    const noise = (Math.random() - 0.5) * 0.03;
    const sizingRate = Math.max(0, baseRate + noise);
    const totalReturns = Math.floor(80 + Math.random() * 40);
    const sizingReturns = Math.floor(totalReturns * sizingRate);

    points.push({
      date,
      totalReturns,
      sizingReturns,
      sizingRate,
    });
  }
  return points;
}

export const MOCK_IMPACT = {
  beforeRate: 0.12,
  afterRate: 0.058,
  variation: -0.052,
  widgetActivatedAt: activatedAt,
  timeSeries: generateTimeSeries(),
};

export const MOCK_CONFIG = {
  threshold: 0.5,
  minSampleSize: 15,
  minCountrySampleSize: 20,
  widgetActivatedAt: activatedAt,
  forcedGender: null,
  wording: {
    runs_large: { en: "Runs large", fr: "Taille grand" },
    runs_small: { en: "Runs small", fr: "Taille petit" },
  },
};
